import { render, staticRenderFns } from "./data-files-per-calendar-week.vue?vue&type=template&id=2b511efc"
import script from "./data-files-per-calendar-week.vue?vue&type=script&lang=js"
export * from "./data-files-per-calendar-week.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports